import { useEffect, useState } from 'react'
import { getLocalStorageValue, setLocalStorageValue } from './store/localstorage'
import { toggleFavoriteIds } from './workoutLogic'

export const FAVORITES_KEY = 'trainer/workoutFavorites'

function parseIds(raw) {
    if (!Array.isArray(raw)) return []
    const seen = new Set()
    const out = []
    for (const value of raw) {
        if (typeof value !== 'number' || !Number.isFinite(value)) continue
        if (seen.has(value)) continue
        seen.add(value)
        out.push(value)
    }
    return out
}

export function useWorkoutFavorites() {
    const [favoriteIds, setFavoriteIds] = useState(() => {
        try {
            return parseIds(getLocalStorageValue(FAVORITES_KEY, []))
        } catch (e) {
            return []
        }
    })
    const [persistFailed, setPersistFailed] = useState(false)

    useEffect(() => {
        const onStorage = event => {
            if (event.key !== FAVORITES_KEY) return
            try {
                setFavoriteIds(parseIds(JSON.parse(event.newValue)))
            } catch (e) {
                // Malformed cross-window writes are ignored; the local state stays usable.
            }
        }
        window.addEventListener('storage', onStorage)
        return () => window.removeEventListener('storage', onStorage)
    }, [])

    const persist = next => {
        setFavoriteIds(next)
        try {
            setLocalStorageValue(FAVORITES_KEY, next)
            setPersistFailed(false)
        } catch (e) {
            setPersistFailed(true)
        }
    }

    const toggleFavorite = id => {
        persist(toggleFavoriteIds(favoriteIds, id))
    }

    return { favoriteIds, toggleFavorite, persistFailed }
}